const meneDataConfig = ({
  menuData: [
    {
      id: '170282217698758656',
      parentId: '',
      name: 'SanDianYiSi',
      type: -1,
      title: '源码熊',
      path: '',
      component: '',
      icon: 'ios-flower',
      url: '',
      buttonType: '',
      children: [
        {
          id: '168931998897803264f',
          parentId: '170282217698758656',
          name: 'home',
          type: 0,
          title: '首 页',
          path: '/',
          component: 'Main',
          icon: 'ios-home',
          url: '',
          buttonType: '',
          children: [
            {
              id: '168932347612237824',
              parentId: '168931998897803264f',
              name: 'tb-home',
              type: 0,
              title: '首 页',
              path: 'home',
              component: 'home/home',
              icon: 'ios-home',
              url: '',
              buttonType: '',
              children: null,
              permTypes: [
                'add',
                'edit',
                'delete'
              ]
            }
          ],
          permTypes: null
        },
        {
          id: '168919490401225216s',
          parentId: '170282217698758656',
          name: 'classManage',
          type: 0,
          title: '班级管理',
          path: '/teacher',
          component: 'Main',
          icon: 'logo-buffer',
          url: '',
          buttonType: '',
          children: [
            {
              id: '168920226101592384',
              parentId: '168919490401225216s',
              name: 'tb-classManage',
              type: 0,
              title: '班级管理',
              path: 'classManage',
              component: 'teacher/classManage',
              icon: 'logo-buffer',
              url: '',
              buttonType: '',
              children: null,
              permTypes: [
                'add',
                'edit',
                'delete'
              ]
            }
          ],
          permTypes: null
        },
        // {
        //   id: '168919490489225216s',
        //   parentId: '170282217698758656',
        //   name: 'stuManage',
        //   type: 0,
        //   title: '课堂点评',
        //   path: '/teacher',
        //   component: 'Main',
        //   icon: 'ios-browsers',
        //   url: '',
        //   buttonType: '',
        //   children: [
        //     {
        //       id: '168920226136592384',
        //       parentId: '168919490489225216s',
        //       name: 'tb-stuManage',
        //       type: 0,
        //       title: '课堂点评',
        //       path: 'stuManage',
        //       component: 'teacher/stuManage',
        //       icon: 'ios-browsers',
        //       url: '',
        //       buttonType: '',
        //       children: null,
        //       permTypes: [
        //         'add',
        //         'edit',
        //         'delete'
        //       ]
        //     }
        //   ],
        //   permTypes: null
        // },
        {
          id: '171327131818814112a',
          parentId: '170282217698758656',
          name: 'studentHomework',
          type: 0,
          title: '学生作业',
          path: '/teacher',
          component: 'Main',
          icon: 'ios-book',
          url: '',
          buttonType: '',
          children: [
            {
              id: '171327339668883136',
              parentId: '171327131818814112a',
              name: 'tb-studentHomework',
              type: 0,
              title: '学生作业',
              path: 'studentHomework',
              component: 'teacher/studentHomework',
              icon: 'ios-book',
              url: null,
              buttonType: '',
              children: null,
              permTypes: [
                'add',
                'edit',
                'delete'
              ]
            }
          ],
          permTypes: null
        },
        {
          id: '171327131818814112a1',
          parentId: '170282217698758656',
          name: 'studentCloudFile',
          type: 0,
          title: '学生云空间',
          path: '/teacher',
          component: 'Main',
          icon: 'ios-book',
          url: '',
          buttonType: '',
          children: [
            {
              id: '17132733966888313611',
              parentId: '171327131818814112a1',
              name: 'tb-studentCloudFile',
              type: 0,
              title: '学生云空间',
              path: 'studentCloudFile',
              component: 'teacher/studentCloudFile',
              icon: 'ios-book',
              url: null,
              buttonType: '',
              children: null,
              permTypes: [
                'add',
                'edit',
                'delete'
              ]
            }
          ],
          permTypes: null
        },
        {
          id: '171327131815542111a',
          parentId: '170282217613758656',
          name: 'preLesson',
          type: 0,
          title: '教师备课',
          path: '/teacher',
          component: 'Main',
          icon: 'ios-paper',
          url: '',
          buttonType: '',
          children: [
            {
              id: '171327339668113136',
              parentId: '171327131815542111a',
              name: 'tb-preLesson',
              type: 0,
              title: '教师备课',
              path: 'preLesson',
              component: 'teacher/preLesson',
              icon: 'ios-paper',
              url: null,
              buttonType: '',
              children: null,
              permTypes: []
            }
          ],
          permTypes: null
        },
        {
          id: '171327131815524111a',
          parentId: '170282217613758656',
          name: 'courseCenter',
          type: 0,
          title: '课程中心',
          path: '/teacher',
          component: 'Main',
          icon: 'ios-pie',
          url: '',
          buttonType: '',
          children: [
            {
              id: '171327339668113136',
              parentId: '171327131815524111a',
              name: 'tb-courseCenter',
              type: 0,
              title: '课程中心',
              path: 'courseCenter',
              component: 'teacher/courseCenter',
              icon: 'ios-pie',
              url: null,
              buttonType: '',
              children: null,
              permTypes: []
            }
          ],
          permTypes: null
        },
        {
          id: '171327131815514112a1',
          parentId: '170282217698758656',
          name: 'opusSquare',
          type: 0,
          title: '作品广场',
          path: '/teacher',
          component: 'Main',
          icon: 'ios-albums',
          url: '',
          buttonType: '',
          children: [
            {
              id: '1713273396684431361',
              parentId: '171327131815514112a1',
              name: 'tb-opusSquare',
              type: 0,
              title: '作品广场',
              path: 'opusSquare',
              component: 'teacher/opusSquareSchool',
              icon: 'ios-albums',
              url: null,
              buttonType: '',
              children: null,
              permTypes: []
            }
          ],
          permTypes: null
        },
        {
          id: '171327131810124112a',
          parentId: '170282217698758656',
          name: 'opusList',
          type: 0,
          title: '作品列表',
          path: '/teacher',
          component: 'Main',
          icon: 'md-filing',
          url: '',
          buttonType: '',
          children: [
            {
              id: '171327339668401236',
              parentId: '171327131810124112a',
              name: 'tb-opusList',
              type: 0,
              title: '作品列表',
              path: 'opusList',
              component: 'teacher/opusList',
              icon: 'md-filing',
              url: null,
              buttonType: '',
              children: null,
              permTypes: []
            }
          ],
          permTypes: null
        },
        {
          id: '171327131810124112a1',
          parentId: '170282217698758656',
          name: 'opusList',
          type: 0,
          title: '广场作品审核',
          path: '/teacher',
          component: 'Main',
          icon: 'md-filing',
          url: '',
          buttonType: '',
          children: [
            {
              id: '171327339668401236',
              parentId: '171327131810124112a1',
              name: 'tb-schoolOpusList',
              type: 0,
              title: '广场作品审核',
              path: 'schoolOpusList',
              component: 'teacher/schoolOpusList',
              icon: 'md-filing',
              url: null,
              buttonType: '',
              children: null,
              permTypes: []
            }
          ],
          permTypes: null
        },
        // {
        //   id: '171127131815514122a',
        //   parentId: '170282217698758656',
        //   name: 'techTrain',
        //   type: 0,
        //   title: '我的师训',
        //   path: '/teacher',
        //   component: 'Main',
        //   icon: 'md-battery-charging',
        //   url: '',
        //   buttonType: '',
        //   children: [
        //     {
        //       id: '171327339668441236',
        //       parentId: '171127131815514122a',
        //       name: 'techTrain',
        //       type: 0,
        //       title: '我的师训',
        //       path: 'techTrain',
        //       component: 'teacher/techTrain',
        //       icon: 'md-battery-charging',
        //       url: null,
        //       buttonType: '',
        //       children: null,
        //       permTypes: []
        //     }
        //   ],
        //   permTypes: null
        // },
        {
          id: '170295815057707110',
          parentId: '170282217698758656',
          name: 'community',
          type: 0,
          title: '成长社区',
          path: '/teacher',
          component: 'Main',
          icon: 'ios-list-box',
          url: '',
          buttonType: '',
          children: [
            {
              id: '170296968898150073',
              parentId: '170295815057707110',
              name: 'tb-community',
              type: 0,
              title: '成长社区',
              path: 'community',
              component: 'teacher/community',
              icon: 'ios-list-box',
              url: '',
              buttonType: '',
              children: null,
              permTypes: []
            }
          ],
          permTypes: null
        },
        // {
        //   id: '170295815057707008',
        //   parentId: '170282217698758656',
        //   name: 'personalCenter',
        //   type: 0,
        //   title: '个人中心',
        //   path: '/teacher',
        //   component: 'Main',
        //   icon: 'md-person',
        //   url: '',
        //   buttonType: '',
        //   children: [
        //     {
        //       id: '170296968898154496',
        //       parentId: '170295815057707008',
        //       name: 'tb-personalCenter',
        //       type: 0,
        //       title: '个人中心',
        //       path: 'personalCenter',
        //       component: 'teacher/personalCenter',
        //       icon: 'md-person',
        //       url: '',
        //       buttonType: '',
        //       children: null,
        //       permTypes: []
        //     }
        //   ],
        //   permTypes: null
        // },

      ],
      permTypes: null
    }
  ]
})
export default meneDataConfig



// WEBPACK FOOTER //
// ./src/data/menuData.js